import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/2c7f9303/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ComponentCode = makeShortcode("ComponentCode");
const ComponentDocs = makeShortcode("ComponentDocs");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <ComponentCode name="Text input" component="text-input" variation="text-input" hasLightVersion hasReactVersion="textinput--default" hasVueVersion="textinput--default" hasAngularVersion="?path=/story/input--input" codepen="EJKNOw" mdxType="ComponentCode" />
    <ComponentCode name="Text area" component="text-area" variation="text-area" hasLightVersion hasReactVersion="textarea--default" hasVueVersion="textarea--default" hasAngularVersion="?path=/story/input--textarea" codepen="JVXbQv" mdxType="ComponentCode" />
    <h2 {...{
      "id": "documentation"
    }}>{`Documentation`}</h2>
    <ComponentDocs component="text-input" mdxType="ComponentDocs" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      